import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EmailEmptydIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "81"}
      height={height || "136.195"}
      viewBox="0 0 81 136.195"
    >
      <g id="Illustration" transform="translate(-833.5 -272)">
        <g id="Email" transform="translate(834 344.355)">
          <g id="Shadow" transform="translate(0 57.841)">
            <ellipse
              id="Ellipse_138"
              data-name="Ellipse 138"
              cx="39.993"
              cy="2.999"
              rx="39.993"
              ry="2.999"
              fill="#ddd"
              opacity="0.5"
            />
          </g>
          <path
            id="Path_10351"
            data-name="Path 10351"
            d="M82-34.89a2.674,2.674,0,0,0-2.666-2.666H4.666A2.674,2.674,0,0,0,2-34.89v43.7a2.674,2.674,0,0,0,2.666,2.666H79.334A2.674,2.674,0,0,0,82,8.806Zm-2.666,0L39.819-12.416,4.666-34.89Z"
            transform="translate(-2 37.557)"
            fill="#f9f9f9"
          />
          <path
            id="Path_10350"
            data-name="Path 10350"
            d="M82-34.89a2.674,2.674,0,0,0-2.666-2.666H4.666A2.674,2.674,0,0,0,2-34.89v43.7a2.674,2.674,0,0,0,2.666,2.666H79.334A2.674,2.674,0,0,0,82,8.806Zm-2.666,0L39.819-12.416,4.666-34.89Zm0,43.7H4.666V-31.558L39.819-9.083,79.334-31.558Z"
            transform="translate(-2 37.557)"
            fill="#ddd"
            stroke="#ddd"
            stroke-width="1"
          />
        </g>
        <g id="Bee" transform="translate(842 272)">
          <g id="Line" transform="translate(0 12.715)">
            <path
              id="Line-2"
              data-name="Line"
              d="M31.878,53.082s-21.639,10.643-30.3-9.106,21.088-42.3,23.972-31.548S-4.148,20.852,7.428,0"
              transform="translate(38.155 0) rotate(43)"
              fill="none"
              stroke="#ddd"
              stroke-width="2"
              stroke-dasharray="5 3"
            />
          </g>
          <g id="bee-2" data-name="bee" transform="translate(38.362)">
            <path
              id="Path_10042"
              data-name="Path 10042"
              d="M5.87,23.906a9.981,9.981,0,0,0,1.935-.2c.326-.065,1.016-.244,1.706-.461,1.33-.419,1.54-.629,1.642-.73a.613.613,0,0,0,.11-.72c-.079-.149-.147-.288-.214-.421a9.83,9.83,0,0,0-.491-.9,7.662,7.662,0,0,0-1.228-1.529,7.752,7.752,0,0,0-2.222-1.625A7.6,7.6,0,0,0,3.924,16.6a3.939,3.939,0,0,0-3.606,1.72c-.595,1.05-.357,2.271.707,3.63a5.969,5.969,0,0,0,2.9,1.717,7.652,7.652,0,0,0,1.94.237Zm0,0"
              transform="translate(0.001 -15.944)"
              fill="#ccc"
              opacity="0.7"
            />
            <path
              id="Path_10043"
              data-name="Path 10043"
              d="M304.855,6.522a.6.6,0,0,0,.1-.008A5.766,5.766,0,0,0,306.5,5.7a5.08,5.08,0,0,0,1.143-1.15,3.138,3.138,0,0,0,.4-3.122A1.606,1.606,0,0,0,306.586.5a2.456,2.456,0,0,0-1.331.454A3.454,3.454,0,0,0,303.816,3.6a4.3,4.3,0,0,0,.526,2.645A.613.613,0,0,0,304.855,6.522Zm0,0"
              transform="translate(-291.469 -0.5)"
              fill="#bbb"
            />
            <path
              id="Path_10044"
              data-name="Path 10044"
              d="M359.254,188.241a6.268,6.268,0,0,0-5.6-3.877,8.438,8.438,0,0,0,.263,5.86,8.141,8.141,0,0,0,4.124,4.707A6.293,6.293,0,0,0,359.254,188.241Zm0,0"
              transform="translate(-338.933 -176.962)"
              fill="#fb972e"
            />
            <path
              id="Path_10045"
              data-name="Path 10045"
              d="M225.942,192.933a9.886,9.886,0,0,1-.446-6.2,6.3,6.3,0,0,0-1.287.379,9.942,9.942,0,0,0-3.194,2.453,12.911,12.911,0,0,0,.9,4.85,12.658,12.658,0,0,0,3.139,4.761c.271.011.536.018.791.018a8.6,8.6,0,0,0,3.175-.469,6.274,6.274,0,0,0,1.173-.639A9.666,9.666,0,0,1,225.942,192.933Zm0,0"
              transform="translate(-212.099 -179.233)"
              fill="#333"
            />
            <path
              id="Path_10046"
              data-name="Path 10046"
              d="M130.293,290.383q-.151.2-.3.407c-1.468,2.051-2.345,4.074-2.345,5.412,0,.588.609.919,1.14,1.141a13.215,13.215,0,0,0,2.042.616,26.639,26.639,0,0,0,2.837.485,14.487,14.487,0,0,1-2.448-4.174A14.7,14.7,0,0,1,130.293,290.383Zm0,0"
              transform="translate(-122.474 -278.651)"
              fill="#fb972e"
            />
          </g>
          <g id="Plus" transform="translate(60.812 30.177)">
            <line
              id="Line_225"
              data-name="Line 225"
              y2="4"
              transform="translate(2)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="2"
            />
            <line
              id="Line_226"
              data-name="Line 226"
              y2="4"
              transform="translate(4 2) rotate(90)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="2"
            />
          </g>
          <g
            id="Ellipse_136"
            data-name="Ellipse 136"
            transform="translate(54.412 42.577)"
            fill="#fff"
            stroke="#707070"
            stroke-width="1"
          >
            <circle cx="0.8" cy="0.8" r="0.8" stroke="none" />
            <circle cx="0.8" cy="0.8" r="0.3" fill="none" />
          </g>
          <g
            id="Ellipse_137"
            data-name="Ellipse 137"
            transform="translate(23.212 16.977)"
            fill="none"
            stroke="#707070"
            stroke-width="1"
          >
            <circle cx="1.6" cy="1.6" r="1.6" stroke="none" />
            <circle cx="1.6" cy="1.6" r="1.1" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
}
